@charset "UTF-8";

/* src/app/shop/productos/product-list/product-list.component.scss */
.container {
  width: 100%;
  height: 100%;
}
app-product-card {
  width: 100%;
}
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
}
app-product-card.in-cart-preview {
  display: block;
  max-width: 297px;
  aspect-ratio: 297/450;
}
app-product-card.in-page {
  display: block;
  max-width: 415px;
  aspect-ratio: 415/568;
}
@media (max-width: 1103px) {
  app-product-card.in-cart-preview {
    max-width: 270px;
  }
}
@media (max-width: 600px) {
  app-product-card.in-page {
    max-width: 352px;
    aspect-ratio: 352/508;
  }
}
swiper-container::part(button-prev),
swiper-container::part(button-next) {
  display: none !important;
}
/*# sourceMappingURL=product-list.component-KSTXT2VT.css.map */
